// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2c0dd5f2","667":"0fccbfd7","977":"ca5c8475"}[chunkId] + ".chunk.js";
};